export function addressDetailsScreen(){
    var address:any = $("#input-service-address").val();
    var apartment:any = $("#input-service-address-2").val();
    var city:any = $("#input-service-city").val();
    var state:any = $("#input-service-state").val();
    var addressParam = address + "&" + apartment + "&" + city + "&" + state + "&" + window.objOSGlobal.requestBodyValues.PostalCode;
    window.objOSGlobal.requestBodyValues.Address = address;
    window.objOSGlobal.requestBodyValues.Address2 = apartment;
    window.objOSGlobal.requestBodyValues.City = city;
    window.objOSGlobal.requestBodyValues.State = state;
}